import constants from '@/utilities/constants';
import guestReaderCheck from './guestReaderCheck';

export default async function (store: any, _to: any, _from: any, next: any) {
  const teamSlug = store.getters.getTeamSlug;
  const settingsUrl = `/${teamSlug}/settings`;

  // Check for guest role first
  const roleCheck = guestReaderCheck(store, next, settingsUrl);
  if (roleCheck) {
    return next(roleCheck);
  }

  // Check if templates feature flag is enabled
  await store.dispatch('getAllTeamFeatures');

  const { featureFlagIds } = constants;
  const areTemplatesEnabled = store.getters.getTeamFeatureEnabled(
    featureFlagIds.cardAndPageTemplates
  );

  // Redirect to profile settings if templates are not enabled
  if (!areTemplatesEnabled) {
    return next({ path: settingsUrl });
  }

  next();
}
